
const moment = require('moment');
import { Moment } from 'moment';
import { ReportCalc } from '../../../services/report.class';
export default class TotalsController {
  months: any[];
  reports: any[];
  selectedMonth: Date = null;
  showReport: boolean = false;
  dataTable: { header: any[], rows: any[] };
  ReportCalc: ReportCalc;
  /*@ngInject*/
  constructor(protected DailyReport) {
    // console.log('totals controller');
    this.getDates();
  }
  getDates() {
    return this.DailyReport.months({}, (months) => {
      // console.log('months', months);
      this.months = months;
    });
  }
  generateReport() {
    this.showReport = false;
    var month: Moment = moment(this.selectedMonth);
    this.DailyReport.all({
      startMonth: month.startOf('month').format('YYYY-MM-DD'),
      endMonth: month.endOf('month').format('YYYY-MM-DD')
    }, result => {
      this.reports = result;
      this.prepareDataForReports(result);
      this.showReport = true;
    })
  }

  prepareDataForReports(reports: any[]) {
    var header: any[] = [];
    var rows: any[] = [];
    reports.forEach(report => {
      var shopIndex = header.map(shop => shop._id).indexOf(report.shop._id);
      if (shopIndex < 0) {
        header.push({ _id: report.shop._id, name: report.shop.name });
      }

      report.reports.forEach(dailyReport => {
        var totalsIndex = rows.map(row => row.date).indexOf(dailyReport.date)
        if (totalsIndex < 0) {
          var drRow = { date: dailyReport.date };
          drRow[report.shop._id] = dailyReport;
          rows.push(drRow);
        } else {
          rows[totalsIndex][report.shop._id] = dailyReport;
        }
      })

    })
    this.dataTable = {
      header: header,
      rows: rows,
    }
  }
  getDailyTotalForShop(row, shop) {
    // console.log('getDailyTotalForShop', row, '\nshop', shop);
    return row[shop._id] ? new ReportCalc(row[shop._id]).getTotal() : 0;
  }
  getDailyTotal(row) {
    // console.log('getDailyTotal', row);
    var total = 0;
    for (var key in row) {
      // console.log('getDailyTotal key', key);
      if (row[key] && key !== 'date') {
        total += new ReportCalc(row[key]).getTotal();
      }
    }
    // console.log('getDailyTotal', total);
    return total;
  }
  getTotalForShop(rows, shop) {
    return rows.map(row => this.getDailyTotalForShop(row, shop)).reduce((prev, current) => prev + current, 0)
  }
  getTotal(rows) {
    
    return rows.map(row => this.getDailyTotal(row)).reduce((prev, current) => prev + current, 0)
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/totals/totals.controller.ts